<ng-container
  *ngIf="
    singleSelectedRow || (consolidatedOrderItems.length > 0 && !isSelectAllRows);
    else noShippingData
  "
>
  <div class="lum-c-sales-order-sidebar">
    <mat-accordion
      *ngIf="!('utah_UTAH-126_tabs_in_s_o_grid_sidebar' | featureFlag)"
      class="lum-accordion"
      togglePosition="before"
      multi
    >
      <mat-expansion-panel
        *ngIf="singleSelectedRow"
        expanded
        class="lum-mat-expansion-panel"
      >
        <mat-expansion-panel-header [@.disabled]="true">
          <mat-panel-title>Shipping</mat-panel-title>
          <lum-sales-order-apply-preset
            *ngIf="
              firstSelectedRowAppIntegrationAccountId &&
              ftApplyPresets &&
              selectedRows.length === 1
            "
            [appIntegrationAccountId]="firstSelectedRowAppIntegrationAccountId"
            (applyPreset)="onApplyPreset($event)"
          ></lum-sales-order-apply-preset>
        </mat-expansion-panel-header>
        <lum-shipping-label-form
          class="d-block mr-2"
          [data]="singleSelectedRow"
          [currentPreset]="
            firstSelectedRowAppIntegrationAccountId ? currentPreset : null
          "
        ></lum-shipping-label-form>
        <button
          class="lum-button lum-button--large mt-3"
          *ngIf="hasShippingLabel"
          (click)="printShippingLabelEvent.emit()"
        >
          <span class="d-flex align-items-center">
            <i class="fas fa-file-export mr-2"></i>
            Print Shipping Label
          </span>
        </button>
      </mat-expansion-panel>

      <mat-expansion-panel
        *ngIf="consolidatedOrderItems.length > 0 && !isSelectAllRows"
        expanded
        class="lum-mat-expansion-panel"
      >
        <mat-expansion-panel-header [@.disabled]="true">
          <mat-panel-title>
            Items
            <span *ngIf="consolidatedOrderItems.length > 0" class="ml-1"
              >({{ (consolidatedOrderItems || []).length }})</span
            ></mat-panel-title
          >
        </mat-expansion-panel-header>
        <div class="d-flex mb-3">
          <div>Orders:</div>
          <button
            *ngIf="selectedRows.length > 7 && showAllOrders"
            type="button"
            class="linkish ml-auto"
            (click)="showAllOrders = !showAllOrders"
            ><small>show fewer orders</small></button
          >
        </div>
        <ng-container
          *ngIf="
            selectedRows.length > truncateOrdersThreshold + 1;
            else whenOrdersUntruncated
          "
        >
          <mat-chip-list *ngIf="selectedRows.length > 0">
            <ng-container
              *ngFor="let row of selectedRows; index as i; trackBy: trackById"
            >
              <mat-chip *ngIf="i < truncateOrdersThreshold || showAllOrders">{{
                row.orderNumber
              }}</mat-chip>
            </ng-container>
            <ng-container *ngIf="!showAllOrders">
              <em>...</em>
              <button
                type="button"
                class="linkish ml-2"
                matTooltip="show all orders"
                [matTooltipShowDelay]="400"
                (click)="showAllOrders = !showAllOrders"
                ><small>+{{ selectedRows.length - truncateOrdersThreshold }}</small>
              </button>
            </ng-container>
          </mat-chip-list>
        </ng-container>
        <ng-template #whenOrdersUntruncated>
          <mat-chip-list *ngIf="selectedRows.length > 0">
            <ng-container
              *ngFor="let row of selectedRows; index as i; trackBy: trackById"
            >
              <mat-chip>{{ row.orderNumber }}</mat-chip>
            </ng-container>
          </mat-chip-list>
        </ng-template>

        <table class="table table-striped">
          <thead>
            <tr>
              <th>SKU</th>
              <th class="text-right">Total Ordered Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of consolidatedOrderItems; trackBy: trackById">
              <td>
                <span class="d-block">{{ item.internalSku }}</span>
                <span class="d-block">{{ item.productName }}</span>
              </td>
              <td class="text-right">{{ item.quantity | decimalPlaces }}</td>
            </tr>
          </tbody>
        </table>
      </mat-expansion-panel>

      <mat-expansion-panel
        *ngIf="selectedRows && selectedRows.length > 1"
        expanded
        class="lum-mat-expansion-panel"
      >
        <mat-expansion-panel-header [@.disabled]="true">
          <mat-panel-title> Bulk Update </mat-panel-title>
          <lum-sales-order-apply-preset
            *ngIf="
              (appIntegrationAccountId || hasSameAppIntegrationId) && ftApplyPresets
            "
            [appIntegrationAccountId]="
              appIntegrationAccountId || commonAppIntegrationAccountId
            "
            (applyPreset)="onApplyPreset($event)"
          ></lum-sales-order-apply-preset>
        </mat-expansion-panel-header>

        <lum-sales-order-sidebar-bulk-update
          [selectedRows]="selectedRows"
          [appIntegrationAccountId]="appIntegrationAccountId"
          [hasSameAppIntegrationId]="hasSameAppIntegrationId"
          [commonAppIntegrationAccountId]="commonAppIntegrationAccountId"
          [currentPreset]="currentPreset"
          (bulkUpdateSuccessEvent)="onBulkUpdateSuccess($event)"
        ></lum-sales-order-sidebar-bulk-update>
      </mat-expansion-panel>

      <mat-expansion-panel
        *ngIf="singleSelectedRow"
        expanded
        class="lum-mat-expansion-panel"
      >
        <mat-expansion-panel-header [@.disabled]="true">
          <mat-panel-title> Recipient </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container *ngIf="singleSelectedRow?.shipTo; else missingShipTo">
          <lum-sales-order-recipient-form
            [salesOrderId]="singleSelectedRow.salesOrderId"
            [data]="singleSelectedRow?.shipTo"
            (updateRecipientForm)="onUpdateRecipientForm($event)"
          ></lum-sales-order-recipient-form>
        </ng-container>
        <ng-template #missingShipTo>
          <div class="d-flex justify-content-between align-items-center my-5">
            <p>No ship-to information available for this order.</p>
          </div>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel expanded class="lum-mat-expansion-panel">
        <mat-expansion-panel-header [@.disabled]="true">
          <mat-panel-title>
            Picklist Preview
            <span
              *ngIf="pickingItems && pickingItems.orders.length > 0"
              class="ml-1"
              >({{ (pickingItems.orders || []).length }})</span
            >
          </mat-panel-title>
        </mat-expansion-panel-header>

        <lum-order-posted-picklist-preview
          [compact]="true"
          [data]="pickingItems"
          [config]="childComponentConfigs.picklistPreviewConfig"
          [loadingPicklistItems]="
            childComponentConfigs.loadingPicklistItems || false
          "
          [appIntegrationAccountId]="appIntegrationAccountId"
          [ftApplyPresets]="ftApplyPresets"
          (quickFulfillmentFlowEvent)="onInitQuickFulfillmentEvent($event)"
          (adjustmentEntryEvent)="onCreateAdjustmentEntry($event)"
        ></lum-order-posted-picklist-preview>
      </mat-expansion-panel>
    </mat-accordion>
    <ng-container *ngIf="'utah_UTAH-126_tabs_in_s_o_grid_sidebar' | featureFlag">
      <mat-expansion-panel
        *ngIf="consolidatedOrderItems.length > 0 && !isSelectAllRows"
        expanded
        class="lum-mat-expansion-panel"
      >
        <mat-expansion-panel-header [@.disabled]="true">
          <mat-panel-title>
            Items
            <span *ngIf="consolidatedOrderItems.length > 0" class="ml-1"
              >({{ (consolidatedOrderItems || []).length }})</span
            ></mat-panel-title
          >
        </mat-expansion-panel-header>
        <div class="d-flex mb-3">
          <div>Orders:</div>
          <button
            *ngIf="selectedRows.length > 7 && showAllOrders"
            type="button"
            class="linkish ml-auto"
            (click)="showAllOrders = !showAllOrders"
            ><small>show fewer orders</small></button
          >
        </div>
        <ng-container
          *ngIf="
            selectedRows.length > truncateOrdersThreshold + 1;
            else whenOrdersUntruncated
          "
        >
          <mat-chip-list *ngIf="selectedRows.length > 0">
            <ng-container
              *ngFor="let row of selectedRows; index as i; trackBy: trackById"
            >
              <mat-chip *ngIf="i < truncateOrdersThreshold || showAllOrders">{{
                row.orderNumber
              }}</mat-chip>
            </ng-container>
            <ng-container *ngIf="!showAllOrders">
              <em>...</em>
              <button
                type="button"
                class="linkish ml-2"
                matTooltip="show all orders"
                [matTooltipShowDelay]="400"
                (click)="showAllOrders = !showAllOrders"
                ><small>+{{ selectedRows.length - truncateOrdersThreshold }}</small>
              </button>
            </ng-container>
          </mat-chip-list>
        </ng-container>
        <ng-template #whenOrdersUntruncated>
          <mat-chip-list *ngIf="selectedRows.length > 0">
            <ng-container
              *ngFor="let row of selectedRows; index as i; trackBy: trackById"
            >
              <mat-chip>{{ row.orderNumber }}</mat-chip>
            </ng-container>
          </mat-chip-list>
        </ng-template>

        <table class="table table-striped">
          <thead>
            <tr>
              <th>SKU</th>
              <th class="text-right">Total Ordered Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of consolidatedOrderItems; trackBy: trackById">
              <td>
                <span class="d-block">{{ item.internalSku }}</span>
                <span class="d-block">{{ item.productName }}</span>
              </td>
              <td class="text-right">{{ item.quantity | decimalPlaces }}</td>
            </tr>
          </tbody>
        </table>
      </mat-expansion-panel>

      <mat-tab-group class="lum-mat-tab-group mt-4" dynamicHeight>
        <mat-tab label="Picklist">
          <ng-template matTabContent>
            Picklist Preview
            <span
              *ngIf="pickingItems && pickingItems.orders.length > 0"
              class="ml-1"
              >({{ (pickingItems.orders || []).length }})</span
            >

            <lum-order-posted-picklist-preview
              [compact]="true"
              [data]="pickingItems"
              [config]="childComponentConfigs.picklistPreviewConfig"
              [loadingPicklistItems]="
                childComponentConfigs.loadingPicklistItems || false
              "
              [appIntegrationAccountId]="appIntegrationAccountId"
              [ftApplyPresets]="ftApplyPresets"
              (quickFulfillmentFlowEvent)="onInitQuickFulfillmentEvent($event)"
              (adjustmentEntryEvent)="onCreateAdjustmentEntry($event)"
            ></lum-order-posted-picklist-preview>
          </ng-template>
        </mat-tab>
        <mat-tab label="Shipping">
          <ng-template matTabContent>
            <ng-container *ngIf="singleSelectedRow; else shippingWhenSelectMany">
              <div class="mb-4">
                <lum-sales-order-apply-preset
                  *ngIf="
                    firstSelectedRowAppIntegrationAccountId &&
                    ftApplyPresets &&
                    selectedRows.length === 1
                  "
                  class="d-flex justify-content-end mb-2"
                  [appIntegrationAccountId]="
                    firstSelectedRowAppIntegrationAccountId
                  "
                  (applyPreset)="onApplyPreset($event)"
                ></lum-sales-order-apply-preset>

                <lum-shipping-label-form
                  class="d-block mr-2"
                  [data]="singleSelectedRow"
                  [currentPreset]="
                    firstSelectedRowAppIntegrationAccountId ? currentPreset : null
                  "
                ></lum-shipping-label-form>
                <button
                  class="lum-button lum-button--large mt-3"
                  *ngIf="hasShippingLabel"
                  (click)="printShippingLabelEvent.emit()"
                >
                  <span class="d-flex align-items-center">
                    <i class="fas fa-file-export mr-2"></i>
                    Print Shipping Label
                  </span>
                </button>
              </div>

              <mat-expansion-panel expanded class="lum-mat-expansion-panel">
                <mat-expansion-panel-header [@.disabled]="true">
                  <mat-panel-title>Recipient</mat-panel-title>
                </mat-expansion-panel-header>
                <ng-container *ngIf="singleSelectedRow?.shipTo; else missingShipTo">
                  <lum-sales-order-recipient-form
                    [salesOrderId]="singleSelectedRow.salesOrderId"
                    [data]="singleSelectedRow?.shipTo"
                    (updateRecipientForm)="onUpdateRecipientForm($event)"
                  ></lum-sales-order-recipient-form>
                </ng-container>
                <ng-template #missingShipTo>
                  <div
                    class="d-flex justify-content-between align-items-center my-5"
                  >
                    <p>No ship-to information available for this order.</p>
                  </div>
                </ng-template>
              </mat-expansion-panel>
            </ng-container>
            <ng-template #shippingWhenSelectMany>
              <lum-sales-order-apply-preset
                *ngIf="
                  (appIntegrationAccountId || hasSameAppIntegrationId) &&
                  ftApplyPresets
                "
                class="d-flex justify-content-end mb-2"
                [appIntegrationAccountId]="
                  appIntegrationAccountId || commonAppIntegrationAccountId
                "
                (applyPreset)="onApplyPreset($event)"
              ></lum-sales-order-apply-preset>

              <lum-sales-order-sidebar-bulk-update
                [selectedRows]="selectedRows"
                [appIntegrationAccountId]="appIntegrationAccountId"
                [hasSameAppIntegrationId]="hasSameAppIntegrationId"
                [commonAppIntegrationAccountId]="commonAppIntegrationAccountId"
                [currentPreset]="currentPreset"
                (bulkUpdateSuccessEvent)="onBulkUpdateSuccess($event)"
              ></lum-sales-order-sidebar-bulk-update>
            </ng-template>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </ng-container>
  </div>
</ng-container>

<ng-template #noShippingData>
  <lum-ui-empty-page
    class="lum-c-sales-order-sidebar lum-c-sales-order-sidebar--empty"
    title="No order is selected"
  ></lum-ui-empty-page>
</ng-template>
